import { PROD, GAMMA, INTEG, REGION } from "../../util/Constants";
import { getRegion } from "../../util/Util";

export function getStage() {
  const url = window.location.href;
  if (url) {
    if (url.includes("integ")) return INTEG;
    else if (url.includes("master")) return GAMMA;
    else return PROD;
  }
  return GAMMA;
}

export const getDolphinAuthBaseURL = () => {
  const region = getRegion();
  switch (getStage()) {
    case INTEG:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_SERVICE.NA.BETA;
        case REGION.EU:
          return DOLPHIN_AUTH_SERVICE.EU.BETA;
        case REGION.IN:
          return DOLPHIN_AUTH_SERVICE.EU.BETA;
        case REGION.JP:
          return DOLPHIN_AUTH_SERVICE.FE.BETA;
        default:
          return DOLPHIN_AUTH_SERVICE.NA.BETA;
      }
    case GAMMA:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_SERVICE.NA.GAMMA;
        case REGION.EU:
          return DOLPHIN_AUTH_SERVICE.EU.GAMMA;
        case REGION.IN:
          return DOLPHIN_AUTH_SERVICE.EU.GAMMA;
        case REGION.JP:
          return DOLPHIN_AUTH_SERVICE.FE.GAMMA;
        default:
          return DOLPHIN_AUTH_SERVICE.NA.BETA;
      }
    case PROD:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_SERVICE.NA.PROD;
        case REGION.EU:
          return DOLPHIN_AUTH_SERVICE.EU.PROD;
        case REGION.IN:
          return DOLPHIN_AUTH_SERVICE.EU.PROD;
        case REGION.JP:
          return DOLPHIN_AUTH_SERVICE.FE.PROD;
        default:
          return DOLPHIN_AUTH_SERVICE.NA.BETA;
      }
    default:
      return DOLPHIN_AUTH_SERVICE.NA.BETA;
  }
};

export const getDolphinAuthAPIKey = () => {
  const region = getRegion();
  switch (getStage()) {
    case INTEG:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_API_KEY.NA.BETA;
        case REGION.EU:
          return DOLPHIN_AUTH_API_KEY.EU.BETA;
        case REGION.IN:
          return DOLPHIN_AUTH_API_KEY.EU.BETA;
        case REGION.JP:
          return DOLPHIN_AUTH_API_KEY.FE.BETA;
        default:
          return DOLPHIN_AUTH_API_KEY.NA.BETA;
      }
    case GAMMA:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_API_KEY.NA.GAMMA;
        case REGION.EU:
          return DOLPHIN_AUTH_API_KEY.EU.GAMMA;
        case REGION.IN:
          return DOLPHIN_AUTH_API_KEY.EU.GAMMA;
        case REGION.JP:
          return DOLPHIN_AUTH_API_KEY.FE.GAMMA;
        default:
          return DOLPHIN_AUTH_API_KEY.NA.BETA;
      }
    case PROD:
      switch (region) {
        case REGION.NA:
          return DOLPHIN_AUTH_API_KEY.NA.PROD;
        case REGION.EU:
          return DOLPHIN_AUTH_API_KEY.EU.PROD;
        case REGION.IN:
          return DOLPHIN_AUTH_API_KEY.EU.PROD;
        case REGION.JP:
          return DOLPHIN_AUTH_API_KEY.FE.PROD;
        default:
          return DOLPHIN_AUTH_API_KEY.NA.BETA;
      }
    default:
      return DOLPHIN_AUTH_API_KEY.NA.BETA;
  }
};

export const DOLPHIN_AUTH_SERVICE = {
  NA: {
    BETA: "https://na-integ-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    GAMMA: "https://na-master-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    PROD: "https://na-prod-fallbacklogin.dolphinprod.last-mile.amazon.dev",
  },
  EU: {
    BETA: "https://na-integ-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    GAMMA: "https://eu-master-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    PROD: "https://eu-prod-fallbacklogin.dolphinprod.last-mile.amazon.dev",
  },
  FE: {
    BETA: "https://na-integ-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    GAMMA: "https://fe-master-fallbacklogin.dolphinprod.last-mile.amazon.dev",
    PROD: "https://fe-prod-fallbacklogin.dolphinprod.last-mile.amazon.dev",
  },
};

export const DOLPHIN_AUTH_API_KEY = {
  NA: {
    BETA: "SCCWebsiteDolphinVerificationBeta-us-east-1",
    GAMMA: "SCCWebsiteDolphinVerificationGamma-us-east-1",
    PROD: "SCCWebsiteDolphinVerificationProd-us-east-1",
  },
  EU: {
    BETA: "SCCWebsiteDolphinVerificationBeta-us-east-1",
    GAMMA: "SCCWebsiteDolphinVerificationGamma-eu-west-1",
    PROD: "SCCWebsiteDolphinVerificationProd-eu-west-1",
  },
  FE: {
    BETA: "SCCWebsiteDolphinVerificationBeta-us-east-1",
    GAMMA: "SCCWebsiteDolphinVerificationGamma-us-west-2",
    PROD: "SCCWebsiteDolphinVerificationProd-us-west-2",
  },
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/network/BaseUrlUtils.js